import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { connect, ConnectedProps } from "react-redux";
import { injectIntl, WrappedComponentProps } from "react-intl";
import { Paper, useMediaQuery, makeStyles, Drawer, TextField, MenuItem } from "@material-ui/core";

// import { actions as tariffsActions } from "../../store/ducks/tariffs.duck";
import { leftMenuActions } from "../../store/ducks/leftMenu.duck";
import { actions as tariffActions } from "../../store/ducks/tariffs.duck";
import { actions as funnelStatesActions } from "../../store/ducks/funnelStates.duck";
import { actions as usersActions } from "../../store/ducks/users.duck";
import { actions as segmentActions } from "../../store/ducks/segment.duck";

import { IAppState } from "../../store/rootDuck";

import { LeftMenu } from ".";
import UsersFilterMenu from "./UsersFilterMenu";
import { accessByRoles } from "../../utils/utils";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flex: "none",
    flexDirection: "column",
    width: 265,
    padding: theme.spacing(2),
    marginRight: theme.spacing(2),
    overflowX: "hidden",
    fontSize: 14,
  },
  left_menu: {
    width: 265,
    padding: theme.spacing(2),
  },
}));

const Wrapper: React.FC<{
  isMinWidthQuery: boolean;
  className: string;
  setCloseDrawer: () => {} | void;
  isMenuOpen: boolean;
}> = ({ isMinWidthQuery, children, className, setCloseDrawer, isMenuOpen }) =>
  isMinWidthQuery ? (
    <Paper className={className}>{children}</Paper>
  ) : (
    <Drawer anchor="left" open={isMenuOpen} onClose={setCloseDrawer}>
      <div className={className}>{children}</div>
    </Drawer>
  );

const GrainMenu: React.FC<PropsFromRedux & WrappedComponentProps> = ({
  intl,
  setLeftMenuOpen,
  setSalePurchaseMode,
  me,
  leftMenuOpen,
  salePurchaseMode,
  cropParams,
  currentFunnelState,
  setFunnelState,
  funnelStates,

  tariffsTypes,
  usersFilterTariff,
  setUsersFilterTariff,
  userRoles,
  setCurrentRoles,
  currentRoles,

  setUserFiltersEmail,
  setUserFiltersPhone,
  clearUserFilters,
  fetchUserFilters,

  userFiltersEmail,
  userFiltersPhone,

  boughtTariff,
  setUserBoughtTariff,
  crops,
  segmentTitles,
  selectedSegments,
  setSelectedSegments,
  setMyClientSelectedRole,
  selectedMyClientRole,
  userActive,
  setUserActive,
  managerIdSelected,
  setManagerIdSelected,
}) => {
  const classes = useStyles();
  const isMinWidthQuery = useMediaQuery("(min-width:1025px)");
  const location = useLocation();

  let bestAllMyDealsMode: "deals" | "best-bids" | "all-bids" | "my-bids" | undefined = undefined;

  const [, , route, cropId] = location.pathname.split("/");
  if (location.pathname === "/deals") {
    bestAllMyDealsMode = "deals";
  } else if (route) {
    if (route === "best-bids") bestAllMyDealsMode = "best-bids";
    if (route === "my-bids") bestAllMyDealsMode = "my-bids";
    if (route === "all-bids") bestAllMyDealsMode = "all-bids";
  }

  const handleSegmentFilter = (key: string, value: string, clear?: boolean) => {
    if (key !== "Все") {
      setSelectedSegments({ ...selectedSegments, [key]: value });
    }
    if (clear) {
      setSelectedSegments({ segment1: "", segment2: "", segment3: "" });
    }
  };

  // if (!me) return null;
  if (accessByRoles(me, ["ROLE_TRANSPORTER"])) return null;

  return (
    <Wrapper
      isMinWidthQuery={isMinWidthQuery}
      className={isMinWidthQuery ? classes.root : classes.left_menu}
      isMenuOpen={leftMenuOpen}
      setCloseDrawer={() => setLeftMenuOpen(false)}
    >
      <LeftMenu
        intl={intl}
        me={me}
        bestAllMyDealsMode={bestAllMyDealsMode}
        cropId={cropId}
        salePurchaseMode={salePurchaseMode}
        setSalePurchaseMode={setSalePurchaseMode}
        setLeftMenuOpen={setLeftMenuOpen}
        enumParams={cropParams && cropParams.filter(item => item.type === "enum")}
        storeCrops={crops}
      />
      {location.pathname === "/my_clients" && (
        <div>
          <TextField
            select
            margin="normal"
            label={intl.formatMessage({ id: "SUBMENU.USER.FILTERS_ROLE" })}
            value={selectedMyClientRole || "ALL"}
            onChange={e => {
              setMyClientSelectedRole(e.target.value);
              handleSegmentFilter("", "", true);
            }}
            name="roles"
            variant="outlined"
          >
            <MenuItem value={"ALL"}>Все</MenuItem>
            <MenuItem value={"ROLE_BUYER"}>{intl.formatMessage({ id: "FUNNEL_STATES.TABS.BUYERS" })}</MenuItem>
            <MenuItem value={"ROLE_VENDOR"}>{intl.formatMessage({ id: "FUNNEL_STATES.TABS.SELLERS" })}</MenuItem>
          </TextField>
          {segmentTitles?.length
            ? segmentTitles?.map(e => {
                const segmentName = e?.name?.split("_");
                if (selectedMyClientRole === "ROLE_BUYER" && e?.name?.indexOf("buyer") !== -1) {
                  return (
                    <TextField
                      key={e?.name + e?.text}
                      select
                      margin="normal"
                      label={e?.text || ""}
                      value={selectedSegments?.[segmentName?.[0]] || "Все"}
                      onChange={item => handleSegmentFilter(segmentName?.[0], item.target.value)}
                      name={segmentName?.[0]}
                      placeholder="Все"
                      variant="outlined"
                    >
                      <MenuItem value={"Все"}>Все</MenuItem>
                      <MenuItem value={"A"}>A</MenuItem>
                      <MenuItem value={"B"}>B</MenuItem>
                      <MenuItem value={"C"}>C</MenuItem>
                    </TextField>
                  );
                }
                if (selectedMyClientRole === "ROLE_VENDOR" && e?.name?.indexOf("vendor") !== -1) {
                  return (
                    <TextField
                      key={e?.name + e?.text}
                      select
                      margin="normal"
                      label={e?.text || ""}
                      value={selectedSegments?.[segmentName?.[0]] || "Все"}
                      onChange={item => handleSegmentFilter(segmentName?.[0], item.target.value)}
                      name={segmentName?.[0]}
                      placeholder="Все"
                      variant="outlined"
                    >
                      <MenuItem value={"Все"}>Все</MenuItem>
                      <MenuItem value={"A"}>A</MenuItem>
                      <MenuItem value={"B"}>B</MenuItem>
                      <MenuItem value={"C"}>C</MenuItem>
                    </TextField>
                  );
                }
                return <></>;
              })
            : null}
        </div>
      )}
      {location.pathname === "/user-list" && (
        <UsersFilterMenu
          me={me}
          intl={intl}
          currentFunnelState={currentFunnelState}
          funnelStates={funnelStates}
          setFunnelState={setFunnelState}
          tariffsTypes={tariffsTypes}
          usersFilterTariff={usersFilterTariff}
          setUsersFilterTariff={setUsersFilterTariff}
          userRoles={userRoles}
          setCurrentRoles={setCurrentRoles}
          currentRoles={currentRoles}
          setUserFiltersEmail={setUserFiltersEmail}
          setUserFiltersPhone={setUserFiltersPhone}
          fetchUserFilters={fetchUserFilters}
          clearUserFilters={clearUserFilters}
          userFiltersEmail={userFiltersEmail}
          userFiltersPhone={userFiltersPhone}
          boughtTariff={boughtTariff}
          setUserBoughtTariff={setUserBoughtTariff}
          handleSegmentFilter={handleSegmentFilter}
          segmentTitles={segmentTitles}
          selectedSegments={selectedSegments}
          userActive={userActive}
          setUserActive={setUserActive}
          isAdmin={!!me?.is_admin}
          managerIdSelected={managerIdSelected}
          setManagerIdSelected={setManagerIdSelected}
        />
      )}
    </Wrapper>
  );
};

const connector = connect(
  (state: IAppState) => ({
    me: state.auth.user,
    leftMenuOpen: state.leftMenu.leftMenuOpen,
    salePurchaseMode: state.leftMenu.salePurchaseMode,
    cropParams: state.crops2.cropParams,
    currentFunnelState: state.funnelStates.currentFunnelState,
    funnelStates: state.funnelStates.funnelStates,
    tariffsTypes: state.tariffs.tariffsTypes,
    usersFilterTariff: state.tariffs.usersFilterTariff,
    userRoles: state.users.roles,
    userFiltersEmail: state.users.userFiltersEmail,
    userFiltersPhone: state.users.userFiltersPhone,
    currentRoles: state.users.currentRoles,
    boughtTariff: state.users.boughtTariff,
    crops: state.crops2.crops,
    selectedSegments: state.segment.selectedSegments,
    segmentTitles: state.segment.segmentTitles,
    selectedMyClientRole: state.users.selectedMyClientRole,
    userActive: state.users.userActive,
    managerIdSelected: state.users.managerIdSelected,
  }),
  {
    ...leftMenuActions,
    setUsersFilterTariff: tariffActions.setUsersFilterTariff,
    setFunnelState: funnelStatesActions.setFunnelState,
    setCurrentRoles: usersActions.setCurrentRoles,
    setSegmentSelected: usersActions.setSegmentSelected,

    setUserFiltersEmail: usersActions.setUserFiltersEmail,
    setUserFiltersPhone: usersActions.setUserFiltersPhone,
    setMyClientSelectedRole: usersActions.setMyClientSelectedRole,
    clearUserFilters: usersActions.clearUserFilters,
    fetchUserFilters: usersActions.userFiltersRequest,

    setUserBoughtTariff: usersActions.setUserBoughtTariff,
    setUserActive: usersActions.setUserActive,
    setManagerIdSelected: usersActions.setManagerIdSelected,
    setSelectedSegments: segmentActions.setSelectedSegments,
  }
);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default injectIntl(connector(GrainMenu));
